'use client'

import ChartCardLoading from '@/components/charts/components/ChartCardLoading'

const ChartAllocationHistoryLoading = () => {
  return (
    <ChartCardLoading
      className="gap-sm"
      padding="m"
      chartClassName="h-[300px]"
      titleClassName="w-[109px]"
      wrapHeader={false}
      controls={['h-8 w-[85px] md:h-8 md:w-[84px]', 'h-8 w-[103px]']}
    />
  )
}

export default ChartAllocationHistoryLoading
